import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface BoxplotSortingControlsProps {
  orderBy: string;
  onOrderByChange: (value: string) => void;
  orderDirection: string;
  onOrderDirectionChange: (value: string) => void;
}

export const BoxplotSortingControls = ({
  orderBy,
  onOrderByChange,
  orderDirection,
  onOrderDirectionChange,
}: BoxplotSortingControlsProps) => {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-sm">Sort by</span>
      <Select value={orderBy} onValueChange={onOrderByChange}>
        <SelectTrigger className="w-[140px] h-8">
          <SelectValue placeholder="Select field" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="node">Node</SelectItem>
          <SelectItem value="min_data">Min</SelectItem>
          <SelectItem value="p25_data">P25</SelectItem>
          <SelectItem value="median_data">Median</SelectItem>
          <SelectItem value="p75_data">P75</SelectItem>
          <SelectItem value="max_data">Max</SelectItem>
        </SelectContent>
      </Select>
      <Select value={orderDirection} onValueChange={onOrderDirectionChange}>
        <SelectTrigger className="w-[140px] h-8">
          <SelectValue placeholder="Select direction" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="ASC">Ascending</SelectItem>
          <SelectItem value="DESC">Descending</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
